import React from 'react';

const BZ = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_184"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_184)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="#003D89"
      />
      <path
        d="M10.5 12C12.9853 12 15 9.98528 15 7.5C15 5.01472 12.9853 3 10.5 3C8.01472 3 6 5.01472 6 7.5C6 9.98528 8.01472 12 10.5 12Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 8H12.5V9H8.5V8Z"
        fill="#CBCBCB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 5H9V6H8V5ZM10 4H11V5H10V4ZM12 5H13V6H12V5ZM13 7H14V8H13V7ZM12 9H13V10H12V9Z"
        fill="#5E9F47"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 6H12V7H11V6Z"
        fill="#580A00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 7H12V8H11V7Z"
        fill="#B54B00"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 6H10V7H9V6Z"
        fill="#BD6100"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 7H10V8H9V7Z"
        fill="#F9B626"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 10H11V11H10V10ZM8 9H9V10H8V9ZM7 7H8V8H7V7Z"
        fill="#5E9F47"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13H21V15H0V13ZM0 0H21V2H0V0Z"
        fill="#D0091E"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default BZ;
